<div class="dialog-header">
    <div class="app-tournament-dialog-ask-player-register-to-next-header-name">
        {{ 'tournament.playAgain.title' | translate }}
    </div>
    <div class="dialog-header-close-button">
        <button (click)="close()">
            <svg-icon src="assets/img/icons/dialog-close.svg"
                [stretch]="true"
                [applyClass]="true"
                class="dialog-header-close-button-icon" />
        </button>
    </div>
</div>
<div class="dialog-content">

    <div class="app-tournament-dialog-ask-player-register-to-next-content-info-item">
        <div class="app-tournament-dialog-ask-player-register-to-next-content-info-item-text">{{ 'tournament.playAgain.message' | translate }}:</div>
        <span class="app-tournament-dialog-ask-player-register-to-next-content-info-item-value">
            {{dialogData.entryFee| gcy: dialogData.currency}} + {{dialogData.houseFee | gcy: dialogData.currency}}
        </span>
    </div>

    <div class="app-tournament-dialog-ask-player-register-to-next-content-info-item">
        <span class="app-tournament-dialog-ask-player-register-to-next-content-info-item-text">{{ 'tournament.registration.currentBalance' | translate }}:</span>
        <span class="app-tournament-dialog-ask-player-register-to-next-content-info-item-value">{{dialogData.playerBalance.availableMoney | gcy: dialogData.currency}}</span>
    </div>

    <div class="app-tournament-dialog-ask-player-register-to-next-content-info-item">
        <div class="app-tournament-dialog-ask-player-register-to-next-content-info-item-text">{{ 'tournament.registration.buyCost' | translate }}:</div>
        <span class="app-tournament-dialog-ask-player-register-to-next-content-info-item-value">
            {{dialogData.entryFee| gcy: dialogData.currency}} + {{dialogData.houseFee | gcy: dialogData.currency}}
        </span>
    </div>
</div>



<div class="dialog-footer">
    <div class="dialog-footer-buttons">
        <button appButton class="success" (click)="buy()">{{ 'common.yes' | translate }}</button>
        <button appButton (click)="close()">{{ 'common.no' | translate }}</button>
    </div>
</div>